import { defineMessages } from 'react-intl';

export const forgotToScanMessages = defineMessages({
  screenTitle: {
    defaultMessage: 'Request Points',
    description: 'Forgot To Scan Screen | Title',
  },
  screenCustomDocumentTitle: {
    defaultMessage: 'Request Points | sweetgreen',
    description: 'Forgot To Scan Screen | Custom Document Title',
  },
});
